import {Root} from '@radix-ui/react-radio-group';

import {style} from '../style';

import type {RadioGroupProps} from '@radix-ui/react-radio-group';

type Props = RadioGroupProps &
  React.RefAttributes<HTMLDivElement> & {
    name: string;
    children: React.ReactNode;
  };
export function StackedRadioGroup({
  className,
  ...props
}: Props): React.JSX.Element {
  return (
    <fieldset aria-label={props.name}>
      <Root {...props} className={style.root}>
        {props.children}
      </Root>
    </fieldset>
  );
}

StackedRadioGroup.displayName = 'StackedRadioGroup';
